import Flex from '@Components/Bases/Flex';
import ScoreDetails from '@Components/ScoreDetails';
import { useGetCGRScore } from '@Domains/CGRScore';
import { Alert, Box, CircularProgress, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useProgressBar } from 'src/Constant/ProgressBarsContext/ProgressBar.Context';
import {
  checkScoreUndefined,
  formatUpdateDate,
  getScoreText,
  getSeverity,
  getStatusMessage,
} from './utils';

const CGRScore = () => {
  const { progressData } = useProgressBar();
  const { id } = useParams();

  const [{ data, loading, error }] = useGetCGRScore(Number(id));
  const [{ data: publishedCGRData, loading: publishedCGRLoading }] =
    useGetCGRScore(Number(id), true);

  const isPublished = Boolean(progressData?.summarizeReport.publishedDate);
  const cgrCriteria = parseInt(process.env.REACT_APP_CGR_CRITERIA || '');

  const { score, updateDate } = data || {};
  const { score: publishedCgrScore, updateDate: publishedCgrUpdateDate } =
    publishedCGRData || {};

  const scoreToCheck = isPublished ? publishedCgrScore : score;
  const isScoreValid =
    scoreToCheck !== null && checkScoreUndefined(scoreToCheck) !== null;
  const isCgrPass =
    typeof scoreToCheck === 'number' ? scoreToCheck >= cgrCriteria : false;
  const isSuccess = !error && data !== undefined;

  if (loading || publishedCGRLoading) {
    return (
      <Flex justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress size={50} />
      </Flex>
    );
  }

  return (
    <Box m={2} bgcolor="white" border="1px solid #E0E0E0">
      <Typography p={1} bgcolor="grey.200" fontWeight="bold">
        สถานะ CGR Score
      </Typography>
      <Alert
        sx={{ margin: 2 }}
        severity={getSeverity(isSuccess, isScoreValid, isCgrPass)}
      >
        {getStatusMessage(isSuccess, isScoreValid, isCgrPass)}
      </Alert>
      <ScoreDetails
        score={
          isPublished
            ? getScoreText(isSuccess, isScoreValid, publishedCgrScore)
            : getScoreText(isSuccess, isScoreValid, score)
        }
        passStatus={isCgrPass}
        updateDate={
          isPublished
            ? formatUpdateDate(publishedCgrUpdateDate)
            : formatUpdateDate(updateDate)
        }
      />
    </Box>
  );
};

export default CGRScore;
